import React from 'react';
import Hero from '../components/landing/Hero';
import Products from '../components/landing/Products';
// import Partners from '../components/landing/Partners';
import Contact from '../components/landing/Contact';
import Footer from '../components/shared/Footer';

function Home() {
  return (
    <div>
      <Hero />
      <Products />
      {/* <Partners /> */}
      <Contact />
      <Footer />
    </div>
  );
}

export default Home;
